import { render, staticRenderFns } from "./OfferSheet.vue?vue&type=template&id=1013fd0f&scoped=true&"
import script from "./OfferSheet.vue?vue&type=script&lang=js&"
export * from "./OfferSheet.vue?vue&type=script&lang=js&"
import style0 from "./OfferSheet.vue?vue&type=style&index=0&id=1013fd0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013fd0f",
  null
  
)

export default component.exports